import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FiAiChatComponent } from '@fi-shared/fi-ai-chat/fi-ai-chat.component';
import { FiAiChatButtonComponent } from '@fi-shared/fi-ai-chat/fi-ai-chat-button/fi-ai-chat-button.component';
import { FiAiChatPanelComponent } from '@fi-shared/fi-ai-chat/fi-ai-chat-panel/fi-ai-chat-panel.component';
import { FiAiChatMarkdownPipe } from '@fi-shared/fi-ai-chat/fi-ai-chat-markdown.pipe';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
@NgModule({
    imports: [CommonModule, FormsModule, MatButtonModule, MatIconModule, MatCardModule, FiAppTextSharedModule],
    declarations: [FiAiChatComponent, FiAiChatButtonComponent, FiAiChatPanelComponent, FiAiChatMarkdownPipe],
    exports: [FiAiChatComponent, FiAiChatButtonComponent],
})
export class FiAiChatModule {}
